<script>
    const axios = require('axios');
    import { useVuelidate } from '@vuelidate/core';
    import { requiredIf } from '@vuelidate/validators';

    const file_size_validation = (value, maxsize, vm) =>  {
        if (!value) {
            return true;
        }
        let file = value;
        return (file.size < maxsize);
    };

    export default {
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                id: 'uid_',
                isDragging: false,
                isUploading: false,
                openModal: false,
                uploadPercentage: [],
                tempFiles: [],
                fileStatus: [],
                processedFiles: [],
                fileIDs: [],
                fileCount: 0,
                currentFileNumber: 0,
                acceptedFiles: [],
                notAllowed: [],
                error: false
            }
        },
        validations() {
            return {
                processedFiles: {
                    required: requiredIf(function (nestedModel) {
                        return this.required && this.processedFiles.length === 0;
                    }),
                    maxNumberOfFiles: function () {
                        if (this.maxFiles === 0) return true
                        return this.processedFiles.length <= this.maxFiles;
                    }
                }
            }
        },
        computed: {
            getTempFiles() {
                return this.tempFiles;
            }
        },
        methods: {
            formatBytes(bytes) {
                if(bytes == 0) return '0 Byte';
                var k = 1000;
                var dm = 2;
                var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            validate() {
                this.v$.$validate();
            },
            async onChange(e) {
                this.tempFiles = [];
                this.fileCount = 0;
                this.tempFiles.push(...e.target.files);
                if (this.tempFiles.length) {
                    this.currentFileNumber = 0;
                    this.error = false;
                    this.notAllowed = [];
                    this.tempFiles.map(f => f.status = 'processing');
                    this.fileCount = this.tempFiles.length;
                    this.isUploading = true;
                    this.openModal = true;
                    this.uploadPercentage = [];
                    for (let index = 0; index < this.tempFiles.length; index++) {
                        this.error = false;
                        this.uploadPercentage[index] = 0;
                        let extension = '.' + this.tempFiles[index].name.split('.').pop();
                        if (!this.acceptedFiles.includes(extension)) {
                            this.notAllowed.push(extension);
                            this.tempFiles[index].status = 'not-allowed';
                            this.error = true;
                        } else if (this.tempFiles[index].size > this.maxSize*1000000) {
                            this.tempFiles[index].status = 'file-too-big';
                        } else {
                            let formData = new FormData();
                            formData.set('file', this.tempFiles[index]);
                            const response = await this.uploadFile(formData, index);
                            if (response && response.status === 200) {
                                if (response.data.typeAlias === 'Success') {
                                    delete this.tempFiles[index].status;
                                    if (this.multiple) {
                                        this.fileIDs.push(response.data.path);
                                        this.processedFiles.push(this.tempFiles[index]);
                                    } else {
                                        this.fileIDs = [response.data.path];
                                        this.processedFiles = [this.tempFiles[index]];
                                    }
                                    this.currentFileNumber++;
                                } else if (response.data.typeAlias === 'FileTooBig') {
                                    this.tempFiles[index].status = 'file-too-big';
                                } else {
                                    this.tempFiles[index].status = 'failed';
                                }
                            } else {
                                this.tempFiles[index].status = 'failed';
                            }
                        }
                    };
                    this.isUploading = false;
                    this.v$.processedFiles.$validate();
                }
            },
            closeModal() {
                this.tempFiles = [];
                this.$refs.fileInput.value = '';
                this.openModal = false;
            },
            removeFile(i) {
                if (confirm(this.remove + ' "' + this.processedFiles[i].name.substr(0,this.processedFiles[i].name.lastIndexOf('.')) + '"?')) {
                    this.fileIDs.splice(i, 1);
                    this.processedFiles.splice(i, 1);
                }
            },
            dragover(e) {
                e.preventDefault();
                this.isDragging = true;
            },
            dragleave() {
                this.isDragging = false;
            },
            drop(e) {
                e.preventDefault();
                this.$refs.fileInput.files = e.dataTransfer.files;
                this.onChange();
                this.isDragging = false;
            },
            async uploadFile(formData, index) {
                try {
                    const response = await axios({
                        method: 'post',
                        url: this.apiUrl,
                        data: formData,
                        headers: { "enctype": "multipart/form-data", "content-type": 'multipart/form-data' },
                        onUploadProgress: function (progressEvent) {
                            this.uploadPercentage[index] = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }.bind(this)
                    })
                    return response;
                } catch (error) {
                    let tempFile = formData.get('file');
                    this.tempFiles.find(f => f.name === tempFile.name)['status'] = 'failed';
                    this.isUploading = false;
                    console.log(error);
                }
            },
        },
        mounted() {
            this.id += this.$.uid.toString();
            this.acceptedFiles = this.accept.split(',');
        },
        props: {
            apiUrl: String,
            multiple: Boolean,
            required: Boolean,
            label: String,
            accept: String,
            uploadText: String,
            dropText: String,
            modalTitle: String,
            buttonText: String,
            fileOf: String,
            fileUploadSingle: String,
            fileUploadPlural: String,
            remove: String,
            failed: String,
            tooBig: String,
            requiredErrorText: String,
            maxFilesErrorText: String,
            maxFilesEqualsText: String,
            errorText: String,
            maxSize: Number,
            maxFiles: { type: Number, default: 0 },
            twoColumn: { type: Boolean, default: true }
        }
    }
</script>

<template>
    <div class="columns is-multiline" v-if="processedFiles.length">
        <div v-for="file in processedFiles" :key="file.name" :class="['column', twoColumn ? 'is-6-tablet' : 'is-12']">
            <div class="p-4 has-border is-flex is-justify-content-space-between is-align-items-center has-background-light file-list">
                <img src="/assets/doctype-icons/excel.svg" alt="excel" width="32" class="file-image"
                     v-if="file.name.split('.').pop() === 'xlsx' || 
                           file.name.split('.').pop() === 'xls' ||
                           file.name.split('.').pop() === 'csv'">
                <img src="/assets/doctype-icons/word.svg" alt="word" width="32" class="file-image"
                     v-else-if="file.name.split('.').pop() === 'docx' || 
                                file.name.split('.').pop() === 'doc' ||
                                file.name.split('.').pop() === 'gdoc'">
                <img src="/assets/doctype-icons/image.svg" alt="image" width="32" class="file-image"
                     v-else-if="file.name.split('.').pop() === 'jpg' || 
                                file.name.split('.').pop() === 'jpeg' ||
                                file.name.split('.').pop() === 'tif' ||
                                file.name.split('.').pop() === 'tiff' ||
                                file.name.split('.').pop() === 'png'">
                <img src="/assets/doctype-icons/pdf.svg" alt="pdf" width="32" class="file-image"
                     v-else-if="file.name.split('.').pop() === 'pdf'">
                <img src="/assets/doctype-icons/unknown.svg" alt="unknown" width="32" class="file-image" v-else>
                <div class="has-ellipsis file-title is-flex-grow-1" :title="file.name.substr(0,file.name.lastIndexOf('.'))">{{file.name.substr(0,file.name.lastIndexOf('.'))}}</div>
                <button class="delete" aria-label="remove" :title="remove" @click="removeFile(processedFiles.indexOf(file))"></button>
            </div>
        </div>
    </div>
    <div class="field">
        <label class="label" :for="id">{{label}}</label>
        <div class="control">
            <div class="file has-name">
                <label :class="['file-label', isDragging ? 'has-background-success-light' : '', (v$.processedFiles.$error && v$.processedFiles.$errors[0].$validator === 'maxNumberOfFiles') || maxFiles && processedFiles.length === maxFiles ? 'disabled' : '']" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                    <input class="file-input" type="file" :id="id" :accept="accept" :multiple="multiple" name="uploadFile" ref="fileInput" @change="onChange" :disabled="maxFiles && maxFiles && processedFiles.length >= maxFiles">
                    <span :class="['file-cta', (v$.processedFiles.$error && v$.processedFiles.$errors[0].$validator === 'maxNumberOfFiles') || (maxFiles && processedFiles.length === maxFiles) ? 'disabled' : '']">
                        <span class="file-icon">
                            <i class="fa-solid fa-upload"></i>
                        </span>
                        <span class="file-label">
                            {{uploadText}}
                        </span>
                    </span>
                    <span :class="['file-name', (v$.processedFiles.$error && v$.processedFiles.$errors[0].$validator === 'maxNumberOfFiles') || (maxFiles && processedFiles.length === maxFiles) ? 'disabled' : '']">
                        {{dropText}}
                    </span>
                </label>
            </div>
        </div>
        <template v-if="v$.processedFiles.$error">
            <span class="form-error has-text-danger" v-if="v$.processedFiles.$errors[0].$validator === 'required'">{{requiredErrorText}}</span>
            <span class="form-error has-text-danger" v-if="v$.processedFiles.$errors[0].$validator === 'maxNumberOfFiles'">{{maxFilesErrorText}}</span>
        </template>
        <span class="form-error has-text-danger is-block" v-if="maxFiles && processedFiles.length === maxFiles">{{maxFilesEqualsText}}</span>
        <span class="form-error has-text-danger is-block" v-if="error">{{errorText}} {{acceptedFiles.map(ext => ext.replace('.','').toUpperCase()).join(', ')}}</span>
    </div>
    <div :class="['modal', openModal ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-centered">{{modalTitle}}</p>
                <button class="delete" aria-label="close" @click="openModal = false" :disabled="isUploading"></button>
            </header>
            <section class="modal-card-body">
                <div class="p-4 my-2 has-border is-flex is-justify-content-space-between is-align-items-center has-background-light file-upload" v-for="(file, index) in getTempFiles" :key="file.status + file.name">
                    <img src="/assets/doctype-icons/excel.svg" alt="excel" width="32" class="file-image"
                         v-if="file.name.split('.').pop() === 'xlsx' || 
                               file.name.split('.').pop() === 'xls' ||
                               file.name.split('.').pop() === 'csv'">
                    <img src="/assets/doctype-icons/word.svg" alt="word" width="32" class="file-image"
                         v-else-if="file.name.split('.').pop() === 'docx' || 
                                    file.name.split('.').pop() === 'doc' ||
                                    file.name.split('.').pop() === 'gdoc'">
                    <img src="/assets/doctype-icons/image.svg" alt="image" width="32" class="file-image"
                         v-else-if="file.name.split('.').pop() === 'jpg' || 
                                    file.name.split('.').pop() === 'jpeg' ||
                                    file.name.split('.').pop() === 'tif' ||
                                    file.name.split('.').pop() === 'tiff' ||
                                    file.name.split('.').pop() === 'png'">
                    <img src="/assets/doctype-icons/pdf.svg" alt="pdf" width="32" class="file-image"
                         v-else-if="file.name.split('.').pop() === 'pdf'">
                    <img src="/assets/doctype-icons/unknown.svg" alt="unknown" width="32" class="file-image" v-else>
                    <div>
                        <div class="has-ellipsis file-title" :title="file.name.substr(0,file.name.lastIndexOf('.'))">{{file.name.substr(0,file.name.lastIndexOf('.'))}}</div>
                        <small class="help">{{formatBytes(file.size)}}</small>
                    </div>
                    <progress v-if="file.status !== 'failed' && file.status !== 'not-allowed' && file.status !== 'file-too-big'" :class="['progress', 'mb-0', 'file-progress', file.status === 'failed' || file.status === 'file-too-big' ? 'is-danger' : 'is-success']" :value="uploadPercentage[index]" max="100">{{uploadPercentage[index]}}%</progress>
                    <div class="has-text-danger file-progress" v-else-if="file.status === 'file-too-big'">{{tooBig}}</div>
                    <div class="has-text-danger file-progress" v-else>{{failed}}</div>
                    <span :class="['icon', uploadPercentage === 100 ? 'has-text-success' : 'has-text-grey-lighter']" v-if="file.status !== 'failed' && file.status !== 'not-allowed' && file.status !== 'file-too-big'">
                        <i v-if="uploadPercentage[index] === 100" class="fa-solid fa-circle-check fa-lg"></i>
                        <i v-else class="fa-solid fa-times-circle"></i>
                    </span>
                    <span class="icon has-text-danger" v-else>
                        <i class="fa-solid fa-circle-exclamation fa-lg"></i>
                    </span>
                </div>
            </section>
            <footer class="modal-card-foot is-flex is-justify-content-space-between is-align-items-center">
                <p>{{currentFileNumber}} {{fileOf}} {{fileCount}} <template v-if="fileCount === 1">{{fileUploadSingle}}</template><template v-else>{{fileUploadPlural}}</template></p>
                <button class="button is-primary" @click.prevent="closeModal()" :disabled="isUploading">{{buttonText}}</button>
            </footer>
        </div>
    </div>
</template>
